import type { LoaderStyles } from './types';

export const LOADER_STYLES: LoaderStyles = {
  lg: {
    gap: 5,
    loaderSize: 32,
  },
  sm: {
    gap: 2,
    loaderSize: 16,
    textVariant: 'body2',
  },
};
